import { reduxActions, apiRoutes, requestStatus, accountConstants, routes, standardHeaders } from '../constants';
import { http } from '../utils';
import { AuthActions } from '../actions';

const { statuses } = accountConstants;

export default class RegisterActions {
    static setApplicationRole(role){
        return {
            type: reduxActions.UPDATE_APPLICATION_ACCOUNT,
            account: {
                role: role
            }
        }
    }

    static updateApplication(account) {
        return {
            type: reduxActions.UPDATE_APPLICATION_ACCOUNT,
            account: account
        }
    }

    static resetApplication() {
        return {
            type: reduxActions.RESET_APPLICATION_ACCOUNT
        }
    }

    static registerNewUser(account) {
        return dispatch => {
            dispatch(RegisterActions.registerStart());
            http.post(apiRoutes.REGISTER, {
                email: account.email,
                password: account.password,
                roles: account.role
            })
            .success(() => {
                dispatch(RegisterActions.registerSuccess());
                dispatch(AuthActions.authenticate({
                    username: account.email,
                    password: account.password
                }, {
                    redirect: routes.VERIFY
                }));
            })
            .error(err => {
                dispatch(RegisterActions.registerFailed(err));
            })
        }
    }

    static registerStart() {
        return {
            type: reduxActions.REGISTRATION_START,
            progress: requestStatus.BUSY,
            message: ''
        }
    }

    static registerSuccess() {
        return {
            type: reduxActions.REGISTRATION_SUCCEEDED,
            progress: requestStatus.ACTIVE,
            message: ''
        }
    }

    static registerFailed(err) {
        return {
            type: reduxActions.REGISTRATION_FAILED,
            progress: requestStatus.ERROR,
            err: err
        }
    }

    static verifyStart() {
        return {
            type: reduxActions.VERIFY_START,
            progress: requestStatus.BUSY,
            message: ''
        }
    }

    static verifySuccess() {
        return {
            type: reduxActions.VERIFY_SUCCEEDED,
            progress: requestStatus.ACTIVE,
            message: ''
        }
    }

    static verifyFailed() {
        return {
            type: reduxActions.VERIFY_FAILED,
            progress: requestStatus.ERROR,
            message: 'Could not complete registration'
        }
    }

    static verifyUser(verification, user) {
        const headers = {};
        headers[standardHeaders.AUTHORIZATION] = 'bearer ' + user['access_token'];

        return dispatch => {
            dispatch(RegisterActions.verifyStart());
            http.post(apiRoutes.VERIFY, verification, {headers})
            .success(() => {
                dispatch(RegisterActions.verifySuccess());
                dispatch(AuthActions.updateApprovalStatus(statuses.SUBMITTED));
            })
            .error(err => {
                dispatch(RegisterActions.verifyFailed(err));
            })
        }
    }
}



// WEBPACK FOOTER //
// ./web-app/actions/register-actions.js